import '../GlowSubWidgets.css';
import React from "react";

function StoppingWork(props) {

    return (
        <div>
            <p> stopping work </p>
        </div>
    )
}

export default StoppingWork;